import { doc, getDoc, setDoc } from "firebase/firestore"
import { getCurrentUser } from "./auth"
import { firestore } from "./firebase"

export function getUserInfo(uid = getCurrentUser()) {
    const userRef = doc(firestore, `users/${uid}`)
    //console.log("uid", getUid())
    return new Promise((resolve, reject) => {
        getDoc(userRef).then((doc) => {
            if (doc.exists()) resolve(doc.data())
            else reject("inexistant")
        }).then(reject)
    })
}

export function setSerial() {
    const serialNumber = sessionStorage.getItem("serialNumber")
    const uid = getCurrentUser()
    const userRef = doc(firestore, `users/${uid}`)
    //console.log("uid", getUid())
    return new Promise((resolve, reject) => {
        setDoc(userRef, { serialNumber: serialNumber }, { merge: true })
            .then(resolve)
            .then(reject)
    })
}